import React from "react";
import GlassCard from "./GlassCard";

interface Props {
  label: string;
  value: string | number;
  icon: string;
  color: string;
  sub?: string;
  trend?: string;
  onClick?: () => void;
}

const StatCard: React.FC<Props> = ({ label, value, icon, color, sub,trend, onClick }) => (
  <GlassCard className="p-5" onClick={onClick} hover={!!onClick}>
    <div className="flex items-start justify-between">
      <div className="flex-1 min-w-0">
        <p className="text-xs font-semibold text-gray-500 uppercase tracking-wider truncate">{label}</p>
        <p className="text-3xl font-bold text-gray-800 mt-1">{value}</p>
        {sub && <p className="text-xs text-gray-400 mt-1">{sub}</p>}
      </div>
      <div
        className="w-12 h-12 rounded-2xl flex items-center justify-center text-2xl flex-shrink-0 ml-3"
        style={{ background: `${color}22` }}
      >
        {icon}
      </div>
    </div>
  </GlassCard>
);

export default StatCard;
